import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/lib/AuthContext";

export function RequireSuperuser({ children, fallback }: { children: ReactNode; fallback?: ReactNode }) {
  const { t } = useTranslation();
  const { user, loading } = useAuth();

  if (loading) {
    return (
      fallback ?? <div className="min-h-screen flex items-center justify-center">{t("common.loading")}</div>
    );
  }

  if (!user?.is_superuser) {
    return <Navigate to="/products" replace />;
  }

  return <>{children}</>;
}
